module.exports = __webpack_public_path__ + "static/media/wings research2.6aac817b.png";